import React from 'react';
import './Card.scss';

const Card=(props)=>{
    return(
        <div   data-aos="fade-up" className={`blog-card ${props.styles}`}
        data-aos-delay={200}>
            <div className="blog-image" style={{ backgroundImage: `url(${props.image})` }}></div>
            <div className="info">
            {props.sub ? <h3>{props.sub}</h3> : null}
            <h2>{props.title}</h2>
           {props.desc ?  <p>{props.desc}</p> : null }
            <h3 className="author"><span>BY</span> {props.by}</h3>
            </div>
        </div>
    )
};
export default Card ;